import { useState, BaseSyntheticEvent } from "react";
import { IoTrashOutline } from "react-icons/io5";
import ModalConfirmation from "./ModalConfirmation";
import TooltipConfig from "../../../../../components/Tooltip";

const RemoveButton = ({ id }: { id: string }) => {
  const [showModal, setShowModal] = useState(false);

  function MouseOver(event: BaseSyntheticEvent) {
    event.target.style.cursor = "pointer";
  }

  const handleModal = (handle: boolean) => {
    setShowModal(handle);
  };

  return (
    <TooltipConfig
      content={["Deletar"]}
      children={
        <>
          <IoTrashOutline
            onMouseOver={MouseOver}
            size={25}
            onClick={() => setShowModal(true)}
          />
          <ModalConfirmation
            show={showModal}
            changeModal={handleModal}
            id={id}
            dash={false}
          />
        </>
      }
      placement={"bottom"}
      style={true}
    />
  );
};

export default RemoveButton;
